import type { SearchResponse } from "@atlas/shared";
import { apiGet } from "../lib/api-client";

export type { SearchResult, SearchResultType, SearchResponse } from "@atlas/shared";

/** Public GET /search (ATL-132): peaks, collections, trails, landmarks, regions by name. */
export function fetchSearch(q: string, limit?: number): Promise<SearchResponse> {
  const params = new URLSearchParams({ q });
  if (limit) params.set("limit", String(limit));
  return apiGet(`/search?${params}`);
}
